import { useEffect } from "react";
import ASSET_PATHS from "../../../assets/config/assetPaths";

interface ToasterProps {
    message: string;
    type: "success" | "error";
    onClose: () => void;
}

const Toaster: React.FC<ToasterProps> = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000);

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div
            className={`fixed flex gap-2 bottom-5 left-1/2 transform -translate-x-1/2 w-11/12 max-w-lg 
        text-white px-3 py-4 rounded-lg shadow-lg z-50 transition-opacity duration-500 ${type === "success" ? "bg-primary" : "bg-red-500"
                }`}
        >
            {
                type == "success" ?
                    <img src={ASSET_PATHS.checkCircleWhite} alt={"Check"} />
                    : <img src={ASSET_PATHS.xCircleWhite} alt={"Check"} />
            }
            <p>{message}</p>
        </div>
    );
};

export default Toaster;
